import { Injectable } from '@angular/core';

interface CustomerTitle {
  title: string;
  name: string;
}

/**
 * CustomerService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/customer/customer.service.ts
 * (legacy AngularJS name 'CustomerService'). Pure, dependency-free helper that
 * holds the customer model shape plus the salutation/title lookup table.
 *
 * Registered back into AngularJS under 'CustomerService' via downgradeInjectable
 * in app/upgrade/ng-downgraded-components.ts, so existing $inject = ['CustomerService']
 * consumers resolve to this Angular 18 class. Wave 3 item #23.
 */
@Injectable({ providedIn: 'root' })
export class CustomerService {
  model = {
    customerSource: '',
    customerId: '',
    externalCustomerImportId: '',
    externalCustomerId: '',
    email: '',
    prefix: '',
    suffix: '',
    firstName: '',
    lastName: '',
    middleName: '',
    phoneNumber: '',
    phoneNotes: '',
    orgName: '',
    deceased: '',
  };

  titles: CustomerTitle[] = [
    { title: 'Ms', name: 'Ms' },
    { title: 'Miss', name: 'Miss' },
    { title: 'Mrs', name: 'Mrs' },
    { title: 'Mr', name: 'Mr' },
    { title: 'Rev', name: 'Rev' },
    { title: 'Dr', name: 'Dr' },
    { title: 'Prof', name: 'Prof' },
  ];

  getTitles(): CustomerTitle[] {
    return this.titles;
  }

  findSalutation(prefix: string): CustomerTitle | undefined {
    return this.titles.find((option) => option.title.toLowerCase() === prefix.toLowerCase());
  }

  getSalutationName(prefix: string): string {
    const found = this.findSalutation(prefix);

    return found ? found.name : '';
  }
}
